import moment from 'moment'
import React from 'react'

import { Occurence } from '../../domain/Error'
import Chart from '../../monitor/histogram.d3'

import dateFormatter from '../../helper/dateFormatter'
import { ErrorHistogramTimerangeSelector } from './ErrorHistogramTimerangeSelector'
import { newResizeObserver } from '../../helper/resizeObserver'

interface Props {
    occurrences: Occurence[]
    height: number
    errorGroupId: string
}

export class ErrorHistogram extends React.Component<Props> {
    public static defaultProps = {
        height: 120,
    }

    public nodes: { svg: SVGSVGElement | null } = { svg: null }
    public chart
    public resizeObserver

    private readonly svgRef: React.RefObject<SVGSVGElement>

    constructor(props: Props, context: unknown) {
        super(props, context)
        this.svgRef = React.createRef()
    }

    private createChart() {
        this.chart = new Chart()

        const chartElement = this.getChartElement()

        if (!chartElement) {
            return
        }

        const parentElement = chartElement.parentElement!
        this.chart.create(chartElement, parentElement.clientWidth, this.props.height, dateFormatter)
        this.updateChart()
    }

    private getChartElement = () => this.svgRef.current

    private setResizeObserver = () => {
        const chartElement = this.getChartElement()
        if (chartElement) {
            const parentNode = jQuery(chartElement).parent()
            this.resizeObserver = newResizeObserver(this.rebuildChart)
            this.resizeObserver.observe(parentNode[0])
        }
    }

    private rebuildChart = () => {
        this.destroyChart()
        this.createChart()
        if (this.chart) this.updateChart()
    }

    private destroyChart() {
        this.chart?.destroy() // remove svg-elements from dom
        this.chart = null // remove reference to the object
    }

    public componentDidMount() {
        if (!this.chart) {
            this.createChart()
        }
    }

    public componentDidUpdate() {
        if (!this.chart) {
            return
        }

        if (!this.resizeObserver && this.chart) {
            this.setResizeObserver()
        }

        this.updateChart()
    }

    public updateChart = () => {
        this.chart.update(
            [
                this.props.occurrences.map(occurrence => ({
                    x: moment(occurrence.start + 'Z').toDate(),
                    end: moment(occurrence.end + 'Z').toDate(),
                    y: occurrence.count,
                })),
            ],
            null,
            dateFormatter,
        )
    }

    public render() {
        return (
            <>
                <ErrorHistogramTimerangeSelector errorGroupId={this.props.errorGroupId} />
                <div className="erroroccurances">
                    <svg ref={this.svgRef} style={{ height: this.props.height }} />
                </div>
            </>
        )
    }
}
